import type { RecurrenceRule } from "@app/core";
import { nextNOccurrences, occurrencesBetween } from "@app/core";

/**
 * Map a single-override's `recurrence_id_ref` from the old segment to the new
 * segment by occurrence ordinal. Returns null when the ref doesn't correspond
 * to any occurrence in the old segment, or when the new segment has fewer
 * occurrences than the ordinal (override has nothing to attach to).
 */
export function remapSingleRef(
  oldRuleAtSplit: RecurrenceRule,
  newRule: RecurrenceRule,
  newDtstartIso: string,
  splitIso: string,
  oldRef: string,
): string | null {
  const oldOccs = occurrencesBetween(
    oldRuleAtSplit,
    new Date(splitIso),
    new Date(oldRef),
  );
  const oldRefTime = new Date(oldRef).getTime();
  const idx = oldOccs.findIndex((d) => d.getTime() === oldRefTime);
  if (idx === -1) return null;
  const newOccs = nextNOccurrences(
    { ...newRule, until: null },
    new Date(new Date(newDtstartIso).getTime() - 1),
    idx + 1,
  );
  return newOccs.length > idx ? newOccs[idx]!.toISOString() : null;
}
